export default {
  brewery: 'pureProjectCellarC',
  info_url: 'http://landing.tavour.com/pureProjectCellarC/',
  title: {
    in_progress: '',
    success: 'You Joined Pure Project\'s Cellar Cyndicate!',
    subtext: "Join Pure Project's Cellar Cyndicate and unlock a year of rare barrel-aged beers.",
    sub_subtext: 'Our non-local membership brings a curated mix of exclusive Cellar Cyndicate bottles and Pure Project favorites, ' +
      'delivered right to your door. Twice a year, we’ll send you six bottles of small-batch stouts and sours, ' +
      'shipped in the spring and the fall for $165 per release (shipping included). ' +
      'It\'s the perfect way to experience these limited brews without a trip to San Diego. ' +
      'We can\'t wait to share them with you!',
  },
  review: {
    summary: [
      'You are joining the Pure Project\'s Cellar Cyndicate. ' +
      'By signing up, your card will be charged $165 for 6 bottles, twice a year (shipping included). ' +
      'You will have the option to opt out by emailing support@tavour.com. You will receive a notification ' +
      'when your box has been charged and shipped!',
    ],
    button_text: 'Join the Cellar Cyndicate!',
  },
};



// WEBPACK FOOTER //
// ./src/settings/pure_project_cellar_c.js